import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button, Box } from '@mui/material';
import { URL } from '../../data/url';
import BookmarkActiveIc from '../../assets/images/ic_bookmark_active.png';
import BookmarkInactiveIc from '../../assets/images/ic_bookmark_inactive.png';
import DeleteIc from '../../assets/images/ic_mybook_delete.png';

const ellipsisStyle = {
  lineHeight: '20px',
  width: '100%',
  maxWidth: '100%',
  minHeight: '30px',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  wordBreak: 'break-word',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  WebkitBoxAlign: 'center',
  textAlign: 'center',
  fontSize: '16px',
};

function MyManualItem({
  manual,
  myManuals,
  selectedMyManual = null,
  hoveredMyManualIdx = null,
  setSelectedMyManual = () => {},
  onRemoveMyManualClick,
  onManualHover = () => {},
  onManualLeave = () => {},
  isFavored,
  onBookMarkAdd,
  onBookMarkRemove,
}) {
  const navigate = useNavigate();

  const isSelected = selectedMyManual?.idx === manual?.idx;
  const isHovered =
    (hoveredMyManualIdx !== null && manual?.idx === hoveredMyManualIdx) ||
    manual?.idx === selectedMyManual?.idx;

  const handleManualHover = manual => {
    onManualHover(manual);
  };

  return (
    <div className="w-full h-[300px] max-h-[300px] flex justify-center items-center">
      <div className="w-[152px] min-h-[198px] flex flex-col">
        <Box
          className="relative w-full h-[198px] min-h-[198px] bg-[white] grow flex justify-center items-center cursor-pointer"
          onMouseEnter={() => handleManualHover(manual)}
          onMouseLeave={onManualLeave}
        >
          <Box
            className="w-full h-full absolute top-0 left-0 right-0 bottom-0"
            style={{
              zIndex: 1,
              background: `url(${manual?.book_imagelink})`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
            }}
          />
          {(isHovered || isSelected) && (
            <Box
              style={{
                zIndex: 2,
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'rgba(0, 0, 0, .3)',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
              }}
              onClick={() => setSelectedMyManual(manual)}
            />
          )}
          <img
            className="cursor-pointer "
            src={isFavored ? BookmarkActiveIc : BookmarkInactiveIc}
            alt="star"
            style={{
              position: 'absolute',
              top: '-9px',
              right: '-6px',
              zIndex: 100,
            }}
            onClick={
              isFavored
                ? () => onBookMarkRemove(manual.idx)
                : () => onBookMarkAdd(manual.idx)
            }
          />
          {isSelected && (
            <div
              className="flex flex-col gap-3 items-center justify-center min-w-[90px] z-3"
              style={{ zIndex: 3 }}
            >
              <Button
                variant="contained"
                sx={{ zIndex: 3, minWidth: '90px', borderRadius: '6px' }}
                onClick={() =>
                  navigate(URL.Vocabulary, {
                    state: { manual: selectedMyManual, myManuals },
                  })
                }
              >
                <div className="flex items-center">새 시험지 제작</div>
              </Button>
              <button
                type="button"
                style={{}}
                onClick={() => onRemoveMyManualClick(manual)}
              >
                <img src={DeleteIc} alt="delete" />
              </button>
            </div>
          )}
        </Box>
        <Box
          className="w-full pt-[20px] h-[60px] cursor-pointer"
          style={ellipsisStyle}
          onMouseEnter={() => handleManualHover(manual)}
          onMouseLeave={onManualLeave}
          onClick={() => setSelectedMyManual(manual)}
        >
          {manual?.book_title ?? '교재'}
        </Box>
      </div>
    </div>
  );
}

MyManualItem.propTypes = {
  manual: PropTypes.shape({
    book_imagelink: PropTypes.string,
    book_isbn: PropTypes.string,
    book_title: PropTypes.string,
    cate_lvl1_idx: PropTypes.number,
    cate_lvl2_idx: PropTypes.number,
    created_at: PropTypes.string,
    created_by: PropTypes.number,
    idx: PropTypes.number,
  }),
  myManuals: PropTypes.array,
  hoveredMyManualIdx: PropTypes.number,
  selectedMyManual: PropTypes.object,
  setSelectedMyManual: PropTypes.func,
  onRemoveMyManualClick: PropTypes.func,
  onManualHover: PropTypes.func,
  onManualLeave: PropTypes.func,
  isFavored: PropTypes.bool.isRequired,
  onBookMarkAdd: PropTypes.func.isRequired,
  onBookMarkRemove: PropTypes.func.isRequired,
};

export default MyManualItem;
